@use '../../../styles/tokens' as *;

.row {
  display: flex;
  align-items: flex-start;
  gap: $gapSnug;
  padding: $paddingSnug 0;
}

.busy {
  opacity: 0.6;
}

.thumbnail {
  flex-shrink: 0;
  width: 6.4rem;
  height: 6.4rem;
  border-radius: $borderRadius;
  overflow: hidden;
  background: $colorLightGray;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.thumbnailLarge {
  width: 20rem;
  height: 20rem;

  img {
    object-fit: contain;
  }
}

.thumbnailButton {
  padding: 0;
  border: 0;
  cursor: zoom-in;

  &:hover,
  &:focus-visible {
    outline: 2px solid $colorBrightBlue;
    outline-offset: 1px;
  }
}

.details {
  flex: 1;
  min-width: 0;
}

// Inline-block so only the name itself is clickable when the heading is a link, while truncation
// still applies.
.featureName {
  display: inline-block;
  max-width: 100%;
  vertical-align: top;
  font-weight: $boldFontWeight;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.meta {
  color: $colorDarkestGray;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.acres {
  display: flex;
  align-items: center;
  gap: $gapSnug;
  color: $colorDarkestGray;
  white-space: nowrap;
}

// Heading and date on one line, with the name truncating and the date always visible.
.headingLine {
  display: flex;
  align-items: baseline;
  gap: $gapSnug;

  .featureName {
    min-width: 0;
  }
}

.headingDate {
  flex: none;
  white-space: nowrap;
}

.partialTag {
  flex-shrink: 0;
}

.trailing {
  display: flex;
  align-items: center;
  gap: $gapSnug;
  flex-shrink: 0;
}

.price {
  font-variant-numeric: tabular-nums;
  font-weight: $boldFontWeight;
}

// Fixed-width remove column, so a card of checkout rows keeps its thumbnails and headings on one
// vertical line.
.leading {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
}

.checkout {
  align-items: center;
  gap: $gapDefault;
  padding: $paddingDefault 0;

  .trailing {
    gap: $space1_5;
  }
}
